var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoreMessagelogsAlertInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warning_20px",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1004",
    "data-name": "Group 1004"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_229",
    "data-name": "Rectangle 229",
    width: 20,
    height: 20,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M7.257,3.1a2,2,0,0,1,3.486,0l5.58,9.921A2,2,0,0,1,14.58,16H3.42a2,2,0,0,1-1.743-2.981Z",
    transform: "translate(1 1)",
    fill: "rgba(240,157,24,0.9)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003",
    transform: "translate(9 8)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_56",
    "data-name": "Line 56",
    y1: 3.663,
    transform: "translate(1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    transform: "translate(0 5.927)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1,
    rx: 1,
    ry: 1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 1,
    cy: 1,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreMessagelogsAlertInfoIcon);
export default __webpack_public_path__ + "static/media/more-messagelogs-alert-info-icon.508032c17408a1febf996089d5e3b0b8.svg";
export { ForwardRef as ReactComponent };